<div class="modal-overlay" (click)="toggleModal()">
    <div class="modal-body" (click)="$event.stopPropagation()">
        <p class="title">{{ title }}</p>
        <p class="sub-title">{{subTitle}}</p>
        <div class="modal-fields">
            <div *ngFor="let field of this.fields; index as idx">
                <label class="field-label">
                    {{field.name}}
                    <span class="required-indicator" *ngIf="field.isMandatory" style="color: #C82E2E">*</span>
                </label>
                <input type="text" *ngIf="field.dataType=='text'" [value]="field.value"
                    (input)="onChange(idx, $any($event.target).value)" class="field-input-text">
            </div>
        </div>
        <div>
            <button class="button-outline" (click)="toggleModal()" type="button">
                Cancel
            </button>
            <button (click)="action()" type="submit" class="button-fill-blue">
                {{ actionButtonTitle }}
            </button>
        </div>
    </div>
</div>